import React, { Component } from 'react';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import authHelper from 'helpers/auth';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';
import rolesHelper from 'helpers/roles';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';

const StyledMenuItem = styled(MenuItem)`
    color: ${ theme.palette.secondary } !important;
`;

class AccountMenu extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            showDialog: false,
        };
    }

    fetchAccounts() {
        this.setState({
            loading: true,
        });

        return apiClient.read(`${ config.getApiBaseUrl() }/@me/accounts`).then((response) => {
            authHelper.setAccounts(response);

            this.setState({
                loading: false,
            });
        });
    }

    setCurrentAccount(account) {
        apiClient.create(`${ config.getApiBaseUrl() }/@me/accounts/${ account.id }/select`).then(() => {
            window.location = '/';
        });
    }

    openDialog = () => {
        this.fetchAccounts();

        this.setState({ showDialog: true });
    }

    closeDialog = () => {
        this.setState({ showDialog: false });
    }

    render() {
        const {
            loading,
            showDialog,
        } = this.state;

        const {
            translate,
        } = this.props;

        const accounts = authHelper.getAccounts();

        if (!accounts || loading) {
            return null;
        }

        return (
            <div>
                <StyledMenuItem primaryText={ authHelper.getAccount() ? authHelper.getAccount().name : translate('menu.topbar.accounts.modal_title') } onClick={ this.openDialog }/>

                <Dialog
                    open={ showDialog }
                    onRequestClose={ this.closeDialog }
                    title={ translate('menu.topbar.accounts.modal_title') }
                >
                    { accounts.map((account) => {
                        const isCurrentAcccount = account.id === authHelper.getAccountId();
                        const role = rolesHelper.getRole(account.role_id);

                        let label = `${ account.name } - ${ translate(`resources.accounts.roles.${ role }`) }`;

                        if (isCurrentAcccount) {
                            label += ` (${ translate('menu.topbar.accounts.current') }) `;
                        }

                        return <MenuItem
                            key={ `account-${ account.id }` }
                            primaryText={ label }
                            disabled={ isCurrentAcccount }
                            onClick={ () => {
                                if (!isCurrentAcccount) {
                                    this.setCurrentAccount(account);
                                }

                                this.closeDialog();
                            } }
                        />;
                    })}
                </Dialog>
            </div>
        );
    }
}

AccountMenu.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(AccountMenu);


// WEBPACK FOOTER //
// ./src/components/layout/Layout/header/AccountMenu.js